import React, { useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import ColumnGroupingTable from "../../../table/ColumnGroupingTable.component";
import { Typography } from "@mui/material";
import { investments } from "../responseApi";
import { useHedgeRatioContext } from "../../../../context/HedgeRatioContext";
import { applyFigureFormatting } from "../../../../utils/utils";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const InvestmentsTable = ({ setInvestmentsTableDatas } = {}) => {
  const { selectedFigureDivisor, selectedDecimalsIn } = useHedgeRatioContext();
  const columns = [
    {
      label: "Investments",
      children: [
        {
          id: "name",
          label: "Name",
          minWidth: 140,
        },
        {
          id: "value",
          label: "Value",
          minWidth: 140,
          align: "right",
        },
      ],
    },
  ];

  const rawTotalValue = useMemo(() => {
    return investments.reduce((sum, investment) => sum + investment.value, 0);
  }, []);

  const investmentDataRows = useMemo(() => {
    return investments?.map(({ name, value }) => ({
      name,
      value: applyFigureFormatting(
        value,
        selectedFigureDivisor,
        selectedDecimalsIn
      ), // 💡 Apply Formatting
      minWidth: 120,
      align: "left",
    }));
  }, [selectedFigureDivisor, selectedDecimalsIn]);

  const totalRow = useMemo(() => {
    return {
      name: "Total Investments",
      value: applyFigureFormatting(
        rawTotalValue,
        selectedFigureDivisor,
        selectedDecimalsIn
      ), // 💡 Apply Formatting
      minWidth: 120,
      align: "left",
      cellStyles: {
        fontWeight: "bold",
        backgroundColor: "#F5F5F5",
        borderTop: "1px solid #000000",
        borderBottom: "1px solid #000000",
      },
    };
  }, [rawTotalValue, selectedFigureDivisor, selectedDecimalsIn]);

  const datas = useMemo(() => {
    return [...investmentDataRows, totalRow];
  }, [investmentDataRows, totalRow]);

  useEffect(() => {
    setInvestmentsTableDatas(datas);
  }, [datas, setInvestmentsTableDatas]);

  return (
    <Grid container spacing={2} sx={{ marginBottom: 0 }}>
      <Grid size={{ xs: 12, md: 12, lg: 12 }}>
        {!investments ? (
          <Item>
            <Typography
              variant="p"
              component="p"
              sx={{
                color: "#adadad",
                minHeight: "250px",
              }}
            >
              There was an error in fetching the data. Please try again later.
            </Typography>
          </Item>
        ) : !investments?.length ? (
          <Item>
            <Typography
              variant="p"
              component="p"
              sx={{
                color: "#adadad",
                minHeight: "250px",
              }}
            >
              No data available for the selected filters.
            </Typography>
          </Item>
        ) : (
          // Investment Table
          <ColumnGroupingTable
            columns={columns}
            datas={datas}
            loading={false}
            disablePagination={true}
            applyThousandsSeparator={true}
            tableHeight={185}
            hideChildRowHeader
          />
        )}
      </Grid>
    </Grid>
  );
};

export default InvestmentsTable;
